<template>
  <article class="m-card-element m-card-element-design-3 m-card-primary m-card-transition">

    <div class="m-card-element-info-data">
      <AtomListElementActionsSecondary
        v-if="!hideMoveIcon"
        :element="element"
      />
      <AtomListElementActionsPrimary
        :element="element"
      />

      <div
        v-if="showSelected && parseInt($route.params.subid) === 3"
        class="m-card-element-info-data-selected"
      >
        {{ $t('mFeedSectionContentCardDesing3.selected') }}
      </div>

      <div
        v-if="!showVideo"
        class="m-card-element-design-3-video"
        @click.prevent="playVideo"
      >
        <img
          v-if="tarjeta.metadata.url_thumbnail"
          :alt="element.nombre"
          :src="tarjeta.metadata.url_thumbnail"
        >
        <img
          v-else
          :alt="element.nombre"
          src="@/assets/img/ds3.png"
        >
        <i
          v-if="tarjeta.metadata.url_thumbnail"
          class="far fa-play-circle m-card-element-design-3-icon"
        >
        </i>
      </div>
      <iframe
        v-else
        :id="tarjeta.metadata.url_video"
        :src="videoUrlParsed"
      >
      </iframe>

      <h5
        v-if="element.categoria"
        key="categoryName"
      >
        {{ productoCategoriaNombre }}
      </h5>
      <h5
        v-else
        key="noCategoryName"
      >
        {{ $t('mFeedSectionContentCardDesing3.noCategoryName') }}
      </h5>

      <h2 class="m-card-element-design-3-name">
        {{ element.nombre }}
      </h2>
    </div>

    <div class="m-card-element-info-state">
      <div class="m-card-element-info-state-of-access">
        <h3
          v-if="element.activo"
          key="available"
        >
         {{ $t('mFeedSectionContentCardDesing3.available') }}
        </h3>
        <h3
          v-else
          key="notAvailable"
        >
          {{ $t('mFeedSectionContentCardDesing3.notAvailable') }}
        </h3>
        <h4
          v-if="element.visible"
          key="visible"
        >
          {{ $t('mFeedSectionContentCardDesing3.visible') }}
        </h4>
        <h4
          v-else
          key="hidden"
        >
          {{ $t('mFeedSectionContentCardDesing3.hidden') }}
        </h4>
      </div>
      <router-link
        class="m-card-element-info-state-of-price"
        :to="`/${$t('rPaths.product')}/${element.id}/${$t('mEditionMenu.product.pricesAndPlans.subject')}`"
      >
        {{ productoPrecio }}
      </router-link>
    </div>

  </article>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentCardDesign3',

  props: {
    element: Object,
    elementCategorias: Array,
    hideMoveIcon: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      showVideo: false,
      tarjeta: {
        tipo: 3,
        metadata: {
          url_thumbnail: '',
          url_video: ''
        }
      }
    }
  },

  computed: {
    productoCategoriaNombre () {
      return this.element.categoria.nombre !== undefined
        ? this.element.categoria.nombre
        : this.elementCategorias.find(categoria => categoria.id_producto_categoria === this.element.categoria.id_producto_categoria).nombre
    },

    productoPrecio () {
      return this.element.pago ? this.$t('mFeedSectionContentCardDesing3.price.buy') : this.$t('mFeedSectionContentCardDesing3.price.free')
    },

    videoUrlParsed () {
      return this.$utils.parseVideo(this.tarjeta.metadata.url_video, true)
    }
  },

  created () {
    if (this.element.tarjeta && this.element.tarjeta === 3) {
      this.tarjeta = Object.assign({}, { tipo: this.element.tarjeta, metadata: Object.assign({}, this.element.metadata) })
    }
  },

  methods: {
    playVideo () {
      if (this.tarjeta.metadata.url_video.length) {
        this.showVideo = true

        setTimeout(() => {
          document.getElementById(this.tarjeta.metadata.url_video).src += '&autoplay=1'
        }, 1200)
      }
    }
  }
}
</script>
